export default "__VITE_ASSET__CG9jl2a5__"